import React, { useEffect, useState } from "react";

import { QRCodeCanvas } from "qrcode.react";
import { Dialog, DialogContent, Paper, Typography } from "@material-ui/core";


import { getSocket, onSocket, cleanupComponent } from "../../services/socket";
import api from "../../services/api";

import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";

const QrcodeModal = ({ open, onClose, whatsAppId }) => {
  const [qrCode, setQrCode] = useState("");

  useEffect(() => {
    if (open) {
      if (!whatsAppId) return;
      const fetchSession = async () => {
        try {
          const { data } = await api.get(`/whatsapp/${whatsAppId}`);
          setQrCode(data.qrcode);
        } catch (err) {
          toastError(err);
        }
      };
      fetchSession();
    }
  }, [whatsAppId, open]);

  useEffect(() => {
    if (open) {
      if (!whatsAppId) return;
      const companyId = localStorage.getItem("companyId");
      const componentId = `QrcodeModal-${whatsAppId}`;
      getSocket({ companyId });

      const handleSessionUpdate = (data) => {
        console.log('entro en whatsappSession:update', data);
        console.log('whatsAppId', whatsAppId);
        if (!data?.session) return;

        const session = data.session;

        if (session.id === whatsAppId) {
          if (session.qrcode === "" || session.qrcode == null) {
            setQrCode("");
            onClose();
          } else {
            setQrCode(session.qrcode);
          }
        } else if (session.qrcode === "") {
          onClose();
        }
      }

      onSocket("whatsappSession:update", handleSessionUpdate, componentId);

      return () => {
        cleanupComponent(componentId);
      };
    }
  }, [whatsAppId, onClose, open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" scroll="paper">
      <DialogContent>
        <Paper elevation={0}>
          <Typography color="primary" gutterBottom>
            {i18n.t("qrCode.message")}
          </Typography>
          {qrCode ? (
            <QRCodeCanvas value={qrCode} size={256} />
          ) : (
            <span>Waiting for QR Code</span>
          )}
        </Paper>
      </DialogContent>
    </Dialog>
  );
};

export default React.memo(QrcodeModal);
